import clsx from 'clsx';
import { Dispatch, SetStateAction } from 'react';
import { EventAccordionItemProps } from 'src/components/Accordions';
import {
  MultiSelectScope,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { EventWithData, PurchaseOrderTicketGroup } from 'src/WebApiController';
import { Feature } from 'src/WebApiController';

import * as styles from '../../Events/EventPage/EventPage.css';

type PurchaseEventContentProps = {
  accordionItemProps?: EventWithData;
  purchaseOrderAccordionItem?: EventAccordionItemProps<PurchaseOrderTicketGroup>;
  selectedPurchaseOrderIds: number[];
  setSelectedPurchaseOrderIds: Dispatch<SetStateAction<number[]>>;
};

export function PurchaseEventInfoSection({
  accordionItemProps,
  purchaseOrderAccordionItem,
  selectedPurchaseOrderIds,
  setSelectedPurchaseOrderIds,
}: PurchaseEventContentProps) {
  const { BodyComponent, AfterHeaderComponent } =
    purchaseOrderAccordionItem || {};
  const hasPurchaseTableV2Feature = useUserHasFeature(Feature.PurchaseTableV2);
  const hasEventListingTableHotkeysFeature = useUserHasFeature(
    Feature.EventListingTableHotkeys
  );
  const { selectionMode } = useMultiSelectionContext();
  const isSelectionModeOn = !!selectionMode?.mode;

  return (
    <div className={styles.tableSection}>
      {BodyComponent && accordionItemProps && (
        <div
          className={clsx(
            styles.tableContainer,
            styles.eventPageTableContainer
          )}
        >
          <div className={styles.bulkActionsStickyWrapper}>
            {AfterHeaderComponent && (
              <AfterHeaderComponent
                displayMode={
                  hasPurchaseTableV2Feature ? 'count-only' : undefined
                }
              />
            )}
          </div>
          <div
            className={clsx(styles.eventDetailsBodyWrapper, {
              [styles.eventDetailsBodyPadding]: !isSelectionModeOn,
            })}
          >
            <BodyComponent
              event={accordionItemProps.event}
              entities={accordionItemProps.entities.ticketGroups ?? []}
              entitiesSummary={accordionItemProps.entities.ticketGroupsSummary}
              entityCount={accordionItemProps.counts.tktGrpsCnt ?? 0}
              selectedIds={selectedPurchaseOrderIds}
              onItemSelectionsChanged={(newSelectedIds: number[]) => {
                setSelectedPurchaseOrderIds(newSelectedIds);
              }}
              selectionMode={{ mode: MultiSelectScope.SingleItem }}
              disablePagination
              useTableNavKeys={hasEventListingTableHotkeysFeature}
              useVirtuoso={!hasPurchaseTableV2Feature}
              withOuterPadding={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}
